import React from 'react'

import { ICellRendererParams } from 'ag-grid-community'
import Link from 'next/link'

export function ApplicationLinkRenderer(params: ICellRendererParams) {
  const { data } = params
  const { external_id, name } = data ?? {}
  const defaultTab = 'summary'

  return (
    <>
      {name ? (
        <Link
          href={`/applications/${external_id}/${defaultTab}`}
          className='hover:underline text-blue-600 hover:text-sky-400 visited:text-purple-600'
          target='_blank'
          rel='noopener noreferrer'
        >
          {name ? name : `No Name - Id: ${external_id}`}
        </Link>
      ) : (
        <span>-</span>
      )}
    </>
  )
}
